import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import * as auth from "../../_redux/authRedux";
import { TermOfConditionPage } from "./termConditionText";
function TermsConditionsPage(props) {
  return (
    <div
      className="login login-3 login-signin-on d-flex flex-row-fluid"
      style={{ display: "block" }}
    >
      <div
        className="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid"
        style={{ backgroundImage: "url(/media/bg/bg-3.jpg)" }}
      >
        <div className="col-xl-8 col-lg-10 col-md-12 col-12  p-7 position-relative overflow-hidden">
          <TermOfConditionPage />
        </div>
      </div>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(TermsConditionsPage));
